import GfUploadPod from '@/gf/components/UploadPod'
import { useAddProofOfDeliveriesMutation } from '@/suppliers/_gen/gql'
import useGqlClient from '@/suppliers/hooks/useGqlClient'
import { useNavigate } from 'react-router-dom'
import { useOrderContext } from './context'

const UploadPod = () => {
  const { storeOrderId, refetch } = useOrderContext()
  const navigate = useNavigate()
  const [addPods] = useAddProofOfDeliveriesMutation({ client: useGqlClient() })

  return (
    <GfUploadPod
      add={(urls) => addPods({ variables: { storeOrderId, urls } })}
      onComplete={refetch}
      close={() => navigate(`/orders/${storeOrderId}`)}
      uploadContext="supplier_proof_of_delivery"
    />
  )
}

export default UploadPod
